export const LOGO_BASE_URL = 'https://postofiel.com.br/';
export const DEFAULT_LOGO = '/assets/logo-padrao.png';
